<template>
<div class="y-block-box">
  <div class="y-block-box-title">
    <div class="y-block-title-content-box">
      <slot name="title">
        <div style="display: flex;align-items: flex-end;gap: 4px;">
          <div class="y-block-title-content">{{title}}</div>
          <div class="y-block-title-info">{{info}}</div>
        </div>
      </slot>
    </div>
    <div class="y-block-title-suffix">
      <div style="flex: 1;"></div>
      <slot name="suffix"></slot>
    </div>
  </div>
  <div class="y-block-box-main-content">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "YBlockBox",
  props:{
    title:{
      type:String,
    },
    info:{
      type:String,
    },
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.y-block-box {
  background: linear-gradient(to bottom,#E7F3FF, #fff 40px,#fff);
  border-radius: 8px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 2px #fff solid;
  box-shadow: 2px 2px 6px 1px #EAEDFD;
  &:hover {
    box-shadow: 4px 4px 6px 2px #EDF0FD;
  }
}
.y-block-box-title{
  display: flex;
  padding: 16px 16px 8px 16px;
  .y-block-title-content-box{
    display: flex;
    .y-block-title-content{
      color: #242424;
      font-weight: bold;
      letter-spacing: 2px;
      font-size: @font-size-lg;
    }
    .y-block-title-info{
      font-size: 12px;
      color: #A1ACB9;
      letter-spacing: 1px;
    }
  }
  .y-block-title-suffix{
    flex: 1;
    display: flex;
  }
}
.y-block-box-main-content{
  flex: 1;
  overflow: hidden;
  padding: 8px 16px 16px 16px;
  &:hover{
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/YUI/YBlockBox/index.vue